import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzgzMzcxMzcxfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Luxury short-term rental interior"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 pt-40 pb-24 min-h-screen flex flex-col justify-end">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.3em] uppercase text-brass mb-6" data-testid="hero-overline">
            AKT Global Enterprises · Short-Term Rental Management
          </div>
          <h1 className="font-serif text-cream text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tighter font-light">
            Your property,
            <br />
            <em className="not-italic text-brass">effortlessly hosted.</em>
          </h1>
          <p className="mt-8 text-cream/80 text-base lg:text-lg max-w-xl leading-relaxed">
            We manage boutique short-term rentals from listing to check-out —
            optimizing revenue, delighting guests, and protecting your investment
            with white-glove care.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start gap-4">
            <a
              href="#about"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-cream text-espresso px-8 py-4 uppercase tracking-[0.2em] text-xs hover:bg-brass hover:text-cream transition-colors duration-300"
            >
              Discover Our Approach
              <ArrowRight strokeWidth={1.25} size={16} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#portfolio"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-3 border border-cream/60 text-cream px-8 py-4 uppercase tracking-[0.2em] text-xs hover:bg-cream hover:text-espresso transition-colors duration-300"
            >
              View Portfolio
            </a>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl border-t border-cream/20 pt-8">
          {[
            ["120+", "Properties Managed"],
            ["4.9★", "Guest Rating"],
            ["38%", "Avg. Revenue Lift"],
            ["24/7", "Guest Support"],
          ].map(([n, l]) => (
            <div key={l}>
              <div className="font-serif text-3xl md:text-4xl text-cream">{n}</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-cream/60 mt-2">{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
